export enum AutomationsWalkthroughStepId {
  CommonStep = 'walkthrough-step-automations-1',
  OptimizeStep2 = 'walkthrough-step-automations-optimize-2',
  OptimizeStep3 = 'walkthrough-step-automations-optimize-3',
  OptimizeStep4 = 'walkthrough-step-automations-optimize-4',
  GrowStep2 = 'walkthrough-step-automations-grow-2',
  GrowStep3 = 'walkthrough-step-automations-grow-3',
  WorkflowStep1 = 'walkthrough-step-automations-workflow-1',
  WorkflowStep2 = 'walkthrough-step-automations-workflow-2',
}
